module.exports = __webpack_public_path__ + "img/mark_n.36b55a2e.png";